import ApiService from 'utils/ApiService';


export const search = ({query}) => {
  // const urlParam = {
  //   query,
  // }
  return new ApiService().getFormSchema(query);
}
